import { actionManager } from './actionManager';
import * as actions from './actions';
import * as companyActions from './company/companyActions';
import * as companyGetters from './company/companyGetters';
import * as diaryEntryActions from './diaryEntry/diaryEntryActions';
import * as diaryEntryGetters from './diaryEntry/diaryEntryGetters';
import * as getters from './getters';
import * as keywordActions from './keyword/keywordActions';
import * as mutations from './mutations';
import * as partActions from './part/partActions';
import * as partCommentActions from './partComment/partCommentActions';
import * as personActions from './person/personActions';
import * as personGetters from './person/personGetters';
import * as projectActions from './project/projectActions';
import * as projectGetters from './project/projectGetters';
import * as stageActions from './stage/stageActions';
import * as todoItemActions from './todoItem/todoItemActions';
import * as todoTemplateActions from './todoItem/todoTemplateActions';
import * as todoTemplateGetters from './todoItem/todoTemplateGetters';
import * as inspectionActions from './inspection/inspectionActions';
import * as inspectionTemplateActions from './inspection/inspectionTemplateActions';
import * as inspectionTemplateGetters from './inspection/inspectionTemplateGetters';
import * as undoActions from './undo/undoActions';
import * as undoGetters from './undo/undoGetters';
import * as userActions from './user/userActions';

import companyFiles from './companyFiles';

require('es6-promise').polyfill();

const state = {
  /** @todo Why do we need _id and _rev fields in state? */
  _id: 'vuex',
  _rev: '',
  syncStatus: { status: 'Paused', message: '' },
  user: {},
  loggedin: false,
  isBusy: 0,
  loggedInPerson: {},
  lastCommentReadDateAtLogin: '0000-01-01 00:00:00',
  loggedInUserPartComments: [],
  preview: false,
  selectedDiaryEntry: null,
  selectedPart: null,
  selectedPartComments: [],
  selectedPartTodoItems: [],
  selectedPartInspection: null,
  selectedStage: null,
  currentProject: {},
  currentProjectTodoTemplates: [],
  currentProjectInspectionTemplates: [],
  currentProjectDiaryEntries: [],
  projectList: [],
  parts: {},
  stages: {},
  persons: {},
  companies: {},
  viewSettings: {
    projectPlan: {
      zoomFactor: 1.5,
      zoomFactorPrint: 1,
    },
  },
  undoBufferCursor: 0,
  undoBuffer: {},
  setKeyword: { keyword: [] },
};

// const store = new Vuex.Store({
const vuex = {
  state,
  mutations: mutations.default,
  actions: {
    ...actions,
    ...companyActions,
    ...diaryEntryActions,
    ...keywordActions,
    ...partActions,
    ...partCommentActions,
    ...personActions,
    ...projectActions,
    ...stageActions,
    ...todoItemActions,
    ...todoTemplateActions,
    ...inspectionActions,
    ...inspectionTemplateActions,
    ...undoActions,
    ...userActions,
  },
  getters: {
    ...companyGetters,
    ...diaryEntryGetters,
    ...getters,
    ...personGetters,
    ...projectGetters,
    ...todoTemplateGetters,
    ...inspectionTemplateGetters,
    ...undoGetters,
  },
  modules: {
    companyFiles,
  },
  plugins: [actionManager],
  strict: process.env.NODE_ENV !== 'production',
};

export { vuex };



// WEBPACK FOOTER //
// ./src/store/index.js